import {computed, inject, Injectable} from '@angular/core';
import {lastValueFrom} from 'rxjs';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {PermissionAssignment, PermissionId, PermissionService} from '../../../../../../api';
import {QueryKey} from '../../../../../constants/query-key';

@Injectable()
export class PermissionQueryService {
  private readonly permissionService = inject(PermissionService);

  // Catalog of all available permissions -> drives the matrix columns.
  private readonly catalogQuery = injectQuery(() => ({
    queryKey: [QueryKey.PERMISSION_CATALOG],
    queryFn: () => lastValueFrom(this.permissionService.getPermissionCatalog()),
  }));

  // Every user with their currently assigned permissions -> drives the matrix rows.
  private readonly assignmentsQuery = injectQuery(() => ({
    queryKey: [QueryKey.PERMISSIONS],
    queryFn: () => lastValueFrom(this.permissionService.getPermissionAssignments()),
  }));

  permissions = computed<PermissionId[]>(() => this.catalogQuery.data()?.permissions ?? []);
  assignments = computed<PermissionAssignment[]>(() => this.assignmentsQuery.data()?.users ?? []);
  isLoading = computed(() => this.catalogQuery.isLoading() || this.assignmentsQuery.isLoading());
}
